import { useOrchestratorBaseUrl } from '@/composables/useOrchestratorBaseUrl.js'
import { apiErrorMessage } from '@/services/apiErrorMessage.js'

export function useOrchestratorRequest() {
  const { orchestratorBaseUrl, apiHeaders } = useOrchestratorBaseUrl()

  async function request(path, options = {}) {
    const response = await fetch(`${orchestratorBaseUrl.value}${path}`, {
      ...options,
      headers: {
        ...apiHeaders.value,
        ...(options.headers || {}),
      },
    })

    const data = await response.json().catch(() => ({}))

    return {
      ok: response.ok,
      status: response.status,
      data,
    }
  }

  async function requestJson(path, options = {}) {
    const response = await request(path, options)
    if (!response.ok) {
      throw new Error(apiErrorMessage(response.data, response.status))
    }
    return response.data
  }

  return {
    request,
    requestJson,
  }
}
